import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const getSuggestOrders = createAction(ACTION.GET_SUGGEST_ORDERS.REQUEST);
